/**
 * 정규식 기반 유효성 검사 유틸 (이메일, 비밀번호, 우편, 전화 등)
 */

// 이메일 (엄격: 공백 없는 형식)
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmail = (value) => {
    return value != null && value.trim() !== '' && EMAIL_REGEX.test(String(value).trim());
};

// 비밀번호: 영문+숫자+기호 중 2종류 이상, 6~12자 (단일 종류만으로 된 경우 제외)
const PASSWORD_REGEX =
    /^(?!^\d+$)(?!^[a-zA-Z]+$)(?!^[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$)[a-zA-Z\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{6,12}$/;

export const isValidPassword = (pw) => {
    return pw != null && PASSWORD_REGEX.test(String(pw));
};

// 비밀번호 구성 요소 (영문, 숫자, 특수문자 각각 포함 여부)
const PASSWORD_LETTER_REGEX = /[a-zA-Z]/;
const PASSWORD_NUMBER_REGEX = /\d/;
const PASSWORD_SPECIAL_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

export const hasPasswordLetter = (value) => PASSWORD_LETTER_REGEX.test(value ?? '');
export const hasPasswordNumber = (value) => PASSWORD_NUMBER_REGEX.test(value ?? '');
export const hasPasswordSpecial = (value) => PASSWORD_SPECIAL_REGEX.test(value ?? '');

// 우편번호 (숫자 5자리 또는 5~6자리)
const ZIPCODE_5_REGEX = /^\d{5}$/;
const ZIPCODE_5_6_REGEX = /^\d{5,6}$/;

export const isZipcode5 = (value) => value != null && ZIPCODE_5_REGEX.test(String(value).trim());
export const isZipcode = (value) => value != null && ZIPCODE_5_6_REGEX.test(String(value).trim());

// 전화번호 (하이픈/공백 제거 후 숫자 9~11자리)
export const isPhone = (value) => {
    if (value == null || String(value).trim() === '') return false;
    const digitsOnly = String(value).replace(/[-\s]/g, '');
    return /^\d{9,11}$/.test(digitsOnly);
};

// 숫자만
export const isNumericOnly = (value) => /^\d+$/.test(value ?? '');
